// extracted by mini-css-extract-plugin
export var progressBar = "_ki-0";
export var progressBarInner = "_ki-1";